import { useNavigate, useSearchParams } from "react-router-dom"
import { RegistrationHeader } from "../RegistrationHeader/RegistrationHeader";
import moment from "moment";
import '../../theme/amchi-theme.css'
import { GrievanceAreaDetails } from "./GrievanceAreaDetails/GrievanceAreaDetails";
import { HospitalDetails } from "./HospitalDetails/HospitalDetails";
import { GrievanceDetails } from "./GrievanceDetails/GrievanceDetails";
import { useState } from "react";
import { t } from "i18next";
import { useDispatch } from "react-redux";
import { GrievanceRegistrationPostAPI } from "../../Helper/Redux/Registration/RegistrationSlice";
import { Header } from "../Private/Header/Header";

export const WithoutRegistration = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch()

    const [searchparams] = useSearchParams()
    const CitizenName = searchparams.get('CitizenName')
    const UserName = searchparams.get('UserName')
    const [IsClear, setIsClear] = useState(false)

    const [GrievanceField, setGrievanceField] = useState({
        CenterName: '',
        AreaName: '',
        AreaAdress: '',
        PatientAddress: '',
        PatientName: '',
        ReferredDoctorName: '',
        DoctorAddress: '',
        DoctorName: '',
        HospitalAddress: '',
        HospitalName: '',
        GrievanceDetails: '',
        VanNumber: ''
    })
    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: 'English'
    })
    const [DistrictDDLID, setDistrictDDLID] = useState({
        DDL: [],
        ID: '0',
        Label: 'Select...'
    })
    const [GenderDDLID, setGenderDDLID] = useState({
        DDL: [],
        ID: 0,
        Label: 'Select...'
    })
    const [GrievanceTypeID, setGrievanceTypeID] = useState({
        DDL: [],
        ID: 0,
        Label: 'Select...'
    })
    const [TalukaDDLID, setTalukaDDLID] = useState({
        DDL: [],
        ID: 0,
        Label: 'Select...'
    })
    const [VillageDDLID, setVillageDDLID] = useState({
        DDL: [],
        ID: 0,
        Label: 'Select...'
    })

    const onChange = (e) => {
        const { name, value } = e.target
        setGrievanceField(item => ({
            ...item, [name]: value
        }))
    }

    const handleClear = () => {
        setIsClear(!IsClear)
        setGrievanceField({
            CenterName: '',
            AreaName: '',
            AreaAdress: '',
            PatientAddress: '',
            PatientName: '',
            ReferredDoctorName: '',
            DoctorAddress: '',
            DoctorName: '',
            HospitalAddress: '',
            HospitalName: '',
            GrievanceDetails: '',
            VanNumber: '',
        })
        setDistrictDDLID({
            ...DistrictDDLID,
            ID: 0,
            Label: 'Select...'
        })
        setGenderDDLID({
            ...GenderDDLID,
            ID: 0,
            Label: 'Select...'
        })
        setGrievanceTypeID({
            ...GrievanceTypeID,
            ID: 0,
            Label: 'Select...'
        })
        setTalukaDDLID({
            ...TalukaDDLID,
            ID: 0,
            Label: 'Select...'
        })
        setVillageDDLID({
            ...VillageDDLID,
            ID: 0,
            Label: 'Select...'
        })
    }


    const handleRegister = () => {
        const data = {
            M_IndicatorGrievanceAreaID: GenderDDLID.ID,
            M_DistrictID: DistrictDDLID.ID,
            M_TalukaID: TalukaDDLID.ID,
            M_VillageID: VillageDDLID.ID,
            M_IndicatorGrievanceTypeID: GrievanceTypeID.ID,
            M_UserID: '0',
            GrievanceField: GrievanceField,
            handleClear: handleClear
        }
        dispatch(GrievanceRegistrationPostAPI({ data }))
    }


    return (
        <>
            <div className="am-page" onLoad={() => window.scrollTo(0, 0)}>

                <div className="am-decor" aria-hidden="true">
                    <span className="am-blob am-blob-1"></span>
                    <span className="am-blob am-blob-2"></span>
                    <span className="am-blob am-blob-3"></span>
                </div>

                <RegistrationHeader
                    Language={Language}
                    setLanguage={setLanguage}
                />

                <main className="am-shell am-form-wrap">

                <div className="am-page-head am-rise">
                    <div>
                        <span className="am-pill"><i className="fa-solid fa-file-circle-plus"></i> नागरिक नोंदणीशिवाय</span>
                        <h1>{t('GrievanceRegistration.GrievanceRegistration')}</h1>
                        <p>
                            तीन सोप्या टप्प्यांत तक्रार नोंदवा. <span className="am-req">*</span> चिन्ह असलेली माहिती
                            अनिवार्य आहे; बाकीची माहिती उपलब्ध असेल तरच भरा.
                        </p>
                    </div>
                </div>

                <div className="am-steps am-rise am-rise-2">
                    <span className="am-step"><b>१</b> {t('GrievanceRegistration.GrievanceAreaDetails')}</span>
                    <span className="am-step"><b>२</b> {t('GrievanceRegistration.HospitalDetails')}</span>
                    <span className="am-step"><b>३</b> {t('GrievanceRegistration.GrievanceDetails')}</span>
                </div>

                <p className="am-note-line am-rise am-rise-2">
                    <i className="fa-solid fa-user-shield"></i>
                    <span>तुमची ओळख गोपनीय ठेवली जाते. तक्रार थेट संबंधित यंत्रणेकडे पाठवली जाईल.</span>
                </p>

                <GrievanceAreaDetails
                    Language={Language}
                    DistrictDDLID={DistrictDDLID}
                    setDistrictDDLID={setDistrictDDLID}
                    GenderDDLID={GenderDDLID}
                    setGenderDDLID={setGenderDDLID}
                    TalukaDDLID={TalukaDDLID}
                    setTalukaDDLID={setTalukaDDLID}
                    VillageDDLID={VillageDDLID}
                    setVillageDDLID={setVillageDDLID}
                    GrievanceField={GrievanceField}
                    onChange={onChange}
                    handleClear={handleClear}
                />

                <HospitalDetails
                    GrievanceField={GrievanceField}
                    onChange={onChange}
                    handleClear={handleClear}
                />

                <GrievanceDetails
                    Language={Language}
                    GrievanceField={GrievanceField}
                    GrievanceTypeID={GrievanceTypeID}
                    setGrievanceTypeID={setGrievanceTypeID}
                    onChange={onChange}
                    handleClear={handleClear}
                />

                <div className="am-form-actions am-rise">
                    <button
                        type="button"
                        className="am-btn am-btn--primary"
                        disabled={GenderDDLID.ID == '0' || DistrictDDLID.ID == '0' || GrievanceField.AreaName == '' ||
                            GrievanceField.AreaAdress == '' || GrievanceTypeID.ID == '0' || GrievanceField.GrievanceDetails == ''}
                        onClick={handleRegister}
                    >
                        <i className="fa-solid fa-paper-plane"></i> {t('GrievanceRegistration.Register')}
                    </button>

                    <button type="button"
                        className="am-btn am-btn--ghost"
                        onClick={() => navigate('/')}
                    >
                        <i className="fa-solid fa-arrow-left"></i> {t('GrievanceRegistration.Back')}
                    </button>
                </div>

                <footer className="am-footer">
                    <span>© {moment().format('YYYY')} सार्वजनिक आरोग्य विभाग, महाराष्ट्र शासन · सर्व हक्क राखीव</span>
                    <span>
                        <i className="fa-solid fa-phone-volume"></i> टोल फ्री : <a href="tel:18002334475">1800 233 4475</a>
                    </span>
                </footer>

                </main>
            </div>

        </>
    )
}